import { defineMessages } from 'react-intl';

export default defineMessages({
  returnRequest: {
    id: 'account.returnRequest.title',
    defaultMessage: 'Return Request',
  },
  returnRequestButton: {
    id: 'account.returnRequest.return',
    defaultMessage: 'Return',
  },
  modalHeading: {
    id: 'account.returnRequest.title',
    defaultMessage: 'Return Request',
  },
  orderDate: {
    id: 'account.returnRequest.orderDate',
    defaultMessage: 'You made this order on {date}',
  },
  orderReturnAdditionalReview: {
    id: 'account.returnRequest.reasonOverlayMessageTime',
    defaultMessage:
      'Please note that this purchase was made over {period} days ago, and as such your return request will go through an additional review process.',
  },
  orderReturnSupportInfo: {
    id: 'account.returnRequest.reasonOverlayMessageSupport',
    defaultMessage:
      'If you are experiencing technical issues, please visit our {supportLinkName} section.',
  },
  orderReturnSupportLink: {
    id: 'account.returnRequest.orderReturnSupportLink',
    defaultMessage: 'Support',
  },
  continueToReturnRequest: {
    id: 'account.returnRequest.reasonOverlayContinueButton',
    defaultMessage: 'Continue to Return Request',
  },
  formProductReturn: {
    id: 'account.returnRequest.returnProduct',
    defaultMessage: 'What product do you wish to return?',
  },
  formReturnReason: {
    id: 'account.returnRequest.reason',
    defaultMessage: 'Why do you want to return this product?',
  },
  formReturnInfoPlaceholder: {
    id: 'account.returnRequest.reasonMisc',
    defaultMessage: 'Is there anything else you would like to let us know?',
  },
  formReturnInfoRemaining: {
    id: 'account.returnRequest.reasonCharacterLimit',
    defaultMessage:
      '{charsRemaining, plural, =0 {# characters remaining} one {# character remaining} other {# characters remaining}}',
  },
  formValidationProducts: {
    id: 'account.returnRequest.reasonSelectProduct',
    defaultMessage: 'Please select the product(s) you want to return',
  },
  formValidationReason: {
    id: 'account.returnRequest.reasonSelectReason',
    defaultMessage: 'Please choose a reason',
  },
  formValidationInfo: {
    id: 'account.returnRequest.reasonProvideInfo',
    defaultMessage: 'Please provide more information on your return',
  },
  formSubmit: {
    id: 'account.returnRequest.reasonSubmitRequest',
    defaultMessage: 'Submit request',
  },
  formError: {
    id: 'account.returnRequest.formErrorMessage',
    defaultMessage:
      'Something went wrong. Please try later or contact our Support.',
  },
  returnRequestError: {
    id: 'account.returnRequest.errorMessage',
    defaultMessage:
      'Something has gone wrong, please try again and if the error continues contact Customer Support.',
  },
  returnRequestSuccess: {
    id: 'account.returnRequest.successMessage',
    defaultMessage: 'Your return request has been received.',
  },
  returnRequestInfo: {
    id: 'account.returnRequest.messageMailSent',
    defaultMessage:
      'We have sent you an email regarding your return request. If you have any questions regarding your return, please reply to that email directly. Please allow 3-5 business days for the return request to be handled by our support agents.',
  },
  returnRequestSubmitted: {
    id: 'account.returnRequest.submitted',
    defaultMessage: 'Submitted',
  },

  reasonCompatibility: {
    id: 'account.returnRequest.reasonCompatibility',
    defaultMessage: 'The product is not compatible with my computer',
  },
  reasonOrderHold: {
    id: 'account.returnRequest.reasonOrderHold',
    defaultMessage: 'The product is not compatible with my computer',
  },
  reasonOther: {
    id: 'account.returnRequest.reasonOther',
    defaultMessage: 'Other',
  },
  reasonProductOwned: {
    id: 'account.returnRequest.reasonProductOwned',
    defaultMessage: 'I’ve accidentally purchased a product I already own',
  },
  reasonSatisfaction: {
    id: 'account.returnRequest.reasonSatisfaction',
    defaultMessage: 'I’m not satisfied with the product',
  },
  reasonTechIssues: {
    id: 'account.returnRequest.reasonTechIssues',
    defaultMessage: 'I’m having technical issues with the product',
  },
  reasonWrongDescription: {
    id: 'account.returnRequest.reasonWrongDescription',
    defaultMessage: 'The product does not match the description on the website',
  },
  reasonWrongLicense: {
    id: 'account.returnRequest.reasonWrongLicense',
    defaultMessage: 'I purchased the wrong update or upgrade',
  },
});
